export type ShipCountry = 'CA' | 'US';

export interface OrderBreakdown {
  sets: number;
  country: ShipCountry;
  /** All-inclusive price in CAD (taxes, shipping, and US duties/processing where applicable). */
  grandTotal: number;
}

/** All-inclusive prices in CAD — nothing extra at checkout. */
const ALL_IN_PRICES: Record<ShipCountry, Record<1 | 2, number>> = {
  CA: { 1: 55, 2: 94 },
  US: { 1: 68, 2: 118 },
};

export function calculateOrder(sets: number, country: ShipCountry): OrderBreakdown | null {
  if (sets !== 1 && sets !== 2) return null;
  return {
    sets,
    country,
    grandTotal: ALL_IN_PRICES[country][sets],
  };
}

export function getOrderSummaryLabel(sets: number, country: ShipCountry): string {
  const destination = country === 'CA' ? 'Canada' : 'United States';
  return `${sets} set${sets > 1 ? 's' : ''} — ship to ${destination} (all inclusive)`;
}

export function formatCad(amount: number): string {
  return `$${amount.toFixed(2)} CAD`;
}
